import React from "react";
import { UseFormRegister, FieldErrors } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface ContactInfoFieldsProps {
  register: UseFormRegister<any>;
  errors: FieldErrors<any>;
  showEmail?: boolean;
  disabled?: boolean;
}

const ContactInfoFields: React.FC<ContactInfoFieldsProps> = ({
  register,
  errors,
  showEmail = true,
  disabled = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className={`checkout-form__section ${disabled ? "is-disabled" : ""}`}>
      <h3 className="checkout-form__section-title">
        {t("checkoutForm.sections.contactInfo", "Contact Information")}
      </h3>
      <div className="checkout-form__grid">
        {showEmail && (
          <div className="form-field">
            <label htmlFor="email" className="required">
              {t("checkoutForm.fields.email", "Email Address")}
            </label>
            <input
              id="email"
              type="email"
              {...register("email")}
              className={errors.email ? "has-error" : ""}
              disabled={disabled}
            />
            {errors.email && (
              <p className="form-field__error">
                {errors.email.message as string}
              </p>
            )}
          </div>
        )}

        <div className="form-field">
          <label htmlFor="phone" className="required">
            {t("checkoutForm.fields.phone", "Phone")}
          </label>
          <input
            id="phone"
            type="tel"
            {...register("phone")}
            className={errors.phone ? "has-error" : ""}
            disabled={disabled}
          />
          {errors.phone && (
            <p className="form-field__error">
              {errors.phone.message as string}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactInfoFields;
